import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const LocationDropdown = ({ locationOptions, userlang, slugLinkField, closeMenu }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isInnerDropdownOpen, setIsInnerDropdownOpen] = useState(null);
    const navigate = useNavigate()

    const handleMainToggle = (e) => {
        e.preventDefault();
        setIsDropdownOpen(prev => !prev);
    };

    const handleInnerToggle = (e, i) => {
        e.preventDefault();
        e.stopPropagation(); // Avoid bubbling up
        // setIsInnerDropdownOpen(prev => !prev);
        setIsInnerDropdownOpen(prev => i == prev ? null : i)
    };

    const onClickLocation = (url) => {
        setIsInnerDropdownOpen(null)
        closeMenu()
        navigate(url)
    }


    return (
        <div className="location_mobile">
            <div className="first_loc_drop">
                <a href="javascript:void(0)" onClick={handleMainToggle}>
                    Location
                    <div className="iconRound">
                        <i className={`fa-solid fa-chevron-down ${isDropdownOpen ? 'rotate' : ''}`}></i>
                    </div>
                </a>
            </div>

            <ul
                className="dropDownLocMobile"
                style={{ display: isDropdownOpen ? 'block' : 'none' }}
            >

                {
                    locationOptions.map((item, index) => (
                        <li className="newdropOpen" key={index}>
                            <a className="menu2" href="javascript:void(0)" onClick={(e) => handleInnerToggle(e, index)}>
                                <span onClick={() => onClickLocation((userlang ? '/' + userlang : '') + `/location${item?.[slugLinkField]}`)}>{item?.name}</span>
                                {
                                    item?.children?.length > 0 &&
                                    <div className="iconRound">
                                        <i className={`fa-solid fa-chevron-down ${isInnerDropdownOpen == index ? 'rotate' : ''}`}></i>
                                    </div>
                                }
                            </a>

                            <ul
                                className="innerNewDrop"
                                style={{ display: isInnerDropdownOpen == index ? 'block' : 'none' }}
                            >
                                {item?.children?.length > 0 && item.children.map((subOption, subIndex) => (
                                    <li key={subIndex} ><a href="javascript:void(0)" onClick={() => onClickLocation((userlang ? '/' + userlang : '') + `/location${subOption?.[slugLinkField]}`)}>{subOption?.name}</a></li>
                                ))}
                            </ul>
                        </li>
                    ))
                }

            </ul>
        </div>
    );
};

export default LocationDropdown;
